import {
  UPDATE_PAGINATION,
  RESET_PAGINATION,
} from "./actionTypes"

export const update_pagination = pagination => {
  return {
    type: UPDATE_PAGINATION,
    payload: pagination
  }
}

export const reset_pagination = pagination => {
  return {
    type: RESET_PAGINATION,
    payload: pagination
  }
}